import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { queryParams } from "src/helpers/UrlHelpers";
import callrecorderUrls from "src/configs/callrecorder/callrecorderUrls";

import PageLayout from '../_partials/PageLayout';
import ListTable from "./_partials/_ListTable";
import PageHeader from "src/componets/PageHeader";
import Wrapper from "src/componets/Wrapper";
import Filter from "src/componets/Filter";

const LIMIT = 42;

const NAV_ITEMS: {[index: number]: any} = {
  1: { id: 1, name: 'Active',    url: callrecorderUrls.userNumberSubscriptionsPath({ status: 'active' }) },
  2: { id: 2, name: 'Pending',   url: callrecorderUrls.userNumberSubscriptionsPath({ status: 'pending' }) },
  3: { id: 3, name: 'Cancelled', url: callrecorderUrls.userNumberSubscriptionsPath({ status: 'cancelled' }) },
  4: { id: 4, name: 'Expired',   url: callrecorderUrls.userNumberSubscriptionsPath({ status: 'expired' }) },
};

const UserNumberSubscriptions = () => {
  const [searchParams] = useSearchParams();
  const currentPage = queryParams.getInt(searchParams, 'page') || 1;

  const activeNavId = useMemo(() => {
    const status = searchParams.get('status');
    if (status === 'active') return 1;
    if (status === 'pending') return 2;
    if (status === 'cancelled') return 3;
    if (status === 'expired') return 4;
    return undefined;
  }, [searchParams]);

  const filterParams = useMemo(() => {
    return queryParams.requestParams(
      searchParams,
      {
        limit:  LIMIT,
        offset: (currentPage - 1) * LIMIT
      },
      ['term', 'search_by', 'order_by', 'order', 'date_from', 'date_to', 'status', 'user_id', 'user_number_id']
    );
  }, [searchParams, currentPage]);

  return (
    <PageLayout className='v-user-number-subscriptions'>
      <PageHeader
        title='UN Subscriptions'
        navs={NAV_ITEMS}
        activeId={activeNavId}
        parent={{
          name: 'All',
          url: callrecorderUrls.userNumberSubscriptionsPath()
        }}
      />

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter dateRange />
        </Wrapper>

        <ListTable filterParams={filterParams} limit={LIMIT} />
      </div>
    </PageLayout>
  );
}

export default UserNumberSubscriptions;
